import { isPlatform } from '@ionic/core';
import { IonFooter } from '@ionic/react';
import classNames from 'classnames';
import React from 'react';

import type {
  UiButtonColorType,
  UiButtonRoundType,
  UiButtonSizeType,
} from '@/components/ui/Button';
import { UiButton } from '@/components/ui/Button';
import { UiTypography } from '@/components/ui/Typography';

import './Footer.scss';

export const OnboardingFooter: React.FC<{
  onContinue: () => void;
  disabled?: boolean;
  hidden?: boolean;
  buttonColor?: UiButtonColorType;
  buttonRadius?: UiButtonRoundType;
  buttonSize?: UiButtonSizeType;
  buttonClassName?: string;
  buttonText?: string;
  contentText?: string;
  variant?: 'simple' | 'with-content';
}> = ({
  onContinue,
  disabled,
  hidden,
  buttonColor = 'primary',
  buttonRadius = 'md',
  buttonSize = 'large',
  buttonClassName,
  buttonText,
  contentText,
  variant = 'simple',
}) => {
  React.useEffect(() => {
    const handleNextStep = (event: KeyboardEvent) => {
      if (event.code === 'Space' && !disabled && !hidden) {
        onContinue();
      }
    };

    if (isPlatform('desktop')) {
      document.addEventListener('keypress', handleNextStep);
    }

    return () => {
      if (isPlatform('desktop')) {
        document.removeEventListener('keypress', handleNextStep);
      }
    };
  }, [hidden, disabled, onContinue]);

  return (
    <IonFooter
      className={classNames('onboarding-footer', {
        hidden,
      })}
    >
      {variant === 'with-content' ? (
        <div className="onboarding-footer__container">
          {contentText && (
            <UiTypography
              variant={'title-small'}
              className="onboarding-footer__text"
            >
              {contentText}
            </UiTypography>
          )}
          <UiButton
            disabled={disabled}
            expand="full"
            round={buttonRadius}
            size={buttonSize}
            color={buttonColor}
            className={classNames('onboarding-footer__button', buttonClassName)}
            onClick={onContinue}
            TEST_ID="onboarding-next"
          >
            {buttonText || 'Continue'}
          </UiButton>
        </div>
      ) : (
        <UiButton
          disabled={disabled}
          expand="full"
          round={buttonRadius}
          size={buttonSize}
          color={buttonColor}
          className={classNames('onboarding-footer__button', buttonClassName)}
          onClick={onContinue}
          TEST_ID="onboarding-next"
        >
          {buttonText || 'Continue'}
        </UiButton>
      )}
    </IonFooter>
  );
};
